import { useEffect, useMemo, useState } from 'react'
import { logger } from '../../logger/logger'

const useAudio = url => {
	const audio = useMemo(() => new Audio(url), [url])
	const [playing, setPlaying] = useState(false)

	useEffect(() => {
		if (playing) {
			const doPlay = () => {
				audio.play()
					.catch(() => {
						logger.warn('Failed to play music')
						setTimeout(doPlay, 10000)
					})
			}
			audio.addEventListener('ended', doPlay)
			doPlay()
			return () => audio.removeEventListener('ended', doPlay)
		}
	}, [playing]) // eslint-disable-line react-hooks/exhaustive-deps

	return [playing, setPlaying]
}

export default useAudio
